const defaults = {
	'device.video.input.id': '',
	'device.audio.input.id': 'default',
	'device.audio.output.id': 'default',
	'video.resolution': 'high',
	'user.data': ''
};

class LocalStorageService
{
	constructor(defaults)
	{
		Object.defineProperty(this, '_current', {
			enumerable: false,
			value: new Map()
		});
		for (const key of Object.keys(defaults))
		{
			this._current.set(key, defaults[key]);
			Object.defineProperty(this, key, {
				enumerable: true,
				get: () => this._current.get(key),
				// eslint-disable-next-line no-setter-return
				set: (value) => this.set(key, value)
			});
		}
		this.load();
	}

	/** Load values from storage */
	load()
	{
		for (const key of this._current.keys())
		{
			const stored = localStorage.getItem(`localData.${key}`);

			if (stored !== null)
			{
				this._current.set(key, stored === 'true');
			}
		}
	}

	/** Set stored value, does *not* take effect immediately */
	set(key, value)
	{
		localStorage.setItem(`localData.${key}`, value);
	}

	/** @deprecated Hydrate new keys from pre-existing, ignore null TODO: Remove this function in April 2021 */
	tempSet(key, value)
	{
		if (!value)
		{
			return;
		}

		localStorage.setItem(`localData.${key}`, value);
	}

	/** Remove from storage, revert to the default; does *not* take effect immediately */
	unset(key)
	{
		localStorage.removeItem(`localData.${key}`);
	}

	fetch(key)
	{
		return localStorage.getItem(`localData.${key}`) ?? (defaults[key]);
	}

	/** Dump to json, for debugging */
	toJSON()
	{
		const o = {};

		for (const key of this._current.keys()) o[key] = this._current.get(key);

		return o;
	}

	/** Dump to string, for debugging */
	toString()
	{
		return JSON.stringify(this);
	}
}

export const localData = new LocalStorageService(defaults);
export default localData;
// expose to devtools
Object.assign(window, { localData: localData });
